const restaurantData = [
    {
      id: 1,
      title: "Pizza Paradise",
      location: "123 Main Street",
      rating: 4.5,
      price: "1200",
      food: "Italian",
      img: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=",
      maintitle: "Welcome to Pizza Paradise"
    },
    {
      id: 2,
      title: "Burger Joint",
      location: "456 Elm Street",
      rating: 4.2,
      price: "1500",
      food: "American",
      img: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80",
      maintitle: "Home of Delicious Burgers"
    },
    {
      id: 3,
      title: "Sushi Station",
      location: "789 Oak Street",
      rating: 4.8,
      price: "800",
      food: "Japanese",
      img:"https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=385&q=80",
      maintitle: "Authentic Sushi Experience"
    },
    {
      id: 4,
      title: "Taco Time",
      location: "321 Maple Avenue",
      rating: 4.3,
      price: "999",
      food: "Mexican",
      img:"https://images.unsplash.com/photo-1578474846511-04ba529f0b88?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80",
      maintitle: "Taste the Flavors of Mexico"
    },
    {
      id: 5,
      title: "Curry House",
      location: "987 Cedar Road",
      rating: 4.6,
      price: "1000",
      food: "Indian",
      img:"https://images.unsplash.com/photo-1550966871-3ed3cdb5ed0c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80"      ,
      maintitle: "Exquisite Indian Cuisine"
    },
    {
      id: 6,
      title: "Steakhouse Grill",
      location: "543 Pine Street",
      rating: 4.4,
      price: "2000",
      food: "Steakhouse",
      img: "https://images.unsplash.com/photo-1508424757105-b6d5ad9329d0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=435&q=80",
      maintitle: "Savor the Juicy Steaks"
    },
    {
      id: 7,
      title: "Pasta Palace",
      location: "789 Walnut Avenue",
      rating: 4.7,
      price: "2400",
      food: "Italian",
      img:"https://images.unsplash.com/photo-1574936145840-28808d77a0b6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=435&q=80",
      maintitle: "Indulge in Delicious Pasta"
    },
    {
      id: 8,
      title: "Thai Spice",
      location: "654 Oak Street",
      rating: 4.1,
      price: "1200",
      food: "2000",
      img: "https://images.unsplash.com/photo-1587574293340-e0011c4e8ecf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1032&q=80"
,
      maintitle: "Authentic Thai Cuisine"
    },
    {
      id: 9,
      title: "Seafood Shack",
      location: "321 Beach Boulevard",
      rating: 4.5,
      price: "1000",
      food: "Seafood",
      img: "https://images.unsplash.com/photo-1613274554329-70f997f5789f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80"
,
      maintitle: "Fresh and Flavorful Seafood"
    },
    {
      id: 10,
      title: "Vegetarian Delight",
      location: "987 Green Avenue",
      rating: 4.3,
      price: "2000",
      food: "Vegetarian",
      img:"https://images.unsplash.com/photo-1559339352-11d035aa65de?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80"
      ,
      maintitle: "Delicious Vegetarian Dishes"
    },
    {
      id: 11,
      title: "BBQ Grill House",
      location: "543 Hickory Lane",
      rating: 4.6,
      price: "3000",
      food: "Barbecue",
      img: "https://images.unsplash.com/photo-1560624052-449f5ddf0c31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=435&q=80"
      ,
      maintitle: "Mouthwatering BBQ Flavors"
    },
    {
      id: 12,
      title: "Cafe de Paris",
      location: "321 French Street",
      rating: 4.2,
      price: "5000",
      food: "French",
      img:"https://images.unsplash.com/photo-1560053608-13721e0d69e8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=804",
      maintitle: "A Taste of Paris in Every Bite"
    },
    {
      id: 13,
      title: "Mexican Fiesta",
      location: "987 Sombrero Road",
      rating: 4.4,
      price: "1200",
      food: "Mexican",
      img: "https://images.unsplash.com/photo-1559329007-40df8a9345d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80"
      ,
      maintitle: "Vibrant Mexican Cuisine"
    },
    {
      id: 14,
      title: "Dumpling House",
      location: "543 Dimsum Avenue",
      rating: 4.7,
      price: "1200",
      food: "Chinese",
      img: "https://images.unsplash.com/photo-1554679665-f5537f187268?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80"
      ,
      maintitle: "Authentic Dumplings and Dim Sum"
    },
    {
      id: 15,
      title: "Mediterranean Delights",
      location: "321 Olive Street",
      rating: 4.3,
      price: "999",
      food: "Mediterranean",
      img: "https://images.unsplash.com/photo-1585518419759-7fe2e0fbf8a6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=724&q=80"
      ,
      maintitle: "Taste of the Mediterranean"
    },
    {
      id: 16,
      title: "Sizzling Steakhouse",
      location: "987 Flame Road",
      rating: 4.5,
      price: "1800",
      food: "Steakhouse",
      img: "https://images.unsplash.com/photo-1586999768265-24af89630739?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80",
      maintitle: "Sizzling Steaks Straight from the Grill"
    },
    {
      id: 17,
      title: "Indian Spice",
      location: "543 Masala Lane",
      rating: 4.2,
      price: "1500",
      food: "Indian",
      img: "https://images.unsplash.com/photo-1599458448510-59aecaea4752?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80",
      maintitle: "Authentic Indian Flavors"
    },
    {
      id: 18,
      title: "Crispy Fried Chicken",
      location: "321 Crispy Avenue",
      rating: 4.4,
      price: "1000",
      food: "American",
      img: "https://images.unsplash.com/photo-1579027989536-b7b1f875659b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
      maintitle: "Crunchy and Delicious Fried Chicken"
    },
    {
      id: 19,
      title: "Ramen House",
      location: "987 Noodle Street",
      rating: 4.6,
      price: "1800",
      food: "Japanese",
      img: "https://images.unsplash.com/photo-1570560258879-af7f8e1447ac?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80",
      maintitle: "Satisfying Bowls of Ramen"
    },
    {
      id: 20,
      title: "Gourmet Pizzas",
      location: "543 Artisan Lane",
      rating: 4.3,
      price: "2000",
      food: "Italian",
      img: "https://images.unsplash.com/photo-1543007631-283050bb3e8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80",
      maintitle: "Artisan Pizzas for Pizza Lovers"
    }
  ];
export default restaurantData;  